/**
 * BookDemo API
 *
 * Provides BookDemo-related API functions.
 */

import { BookDemoRequestType } from '../../types/apiResponse/bookDemo'
import { postData } from '../../utils'

/**
 * Submits a book demo request
 *
 * Backend endpoint: POST /book-demo
 *
 * @param bookDemoRequestForm - Book demo request form data
 * @returns Promise that resolves when request is submitted
 *
 * @example
 * ```typescript
 * await postBookDemo({
 *   name: 'John Doe',
 *   email: 'john@example.com',
 *   // ... other fields
 * })
 * ```
 */
export const postBookDemo = async (bookDemoRequestForm: BookDemoRequestType) => {
  await postData('book-demo', bookDemoRequestForm).catch((e) => {
    throw e
  })
}

